/**
 * React Initialization
 * This file ensures React is loaded and available globally
 * before any other module that depends on it.
 */

import React from 'react';
import ReactDOM from 'react-dom';

// Make React available globally for libraries that expect it
if (typeof window !== 'undefined') {
  (window as unknown as { React: typeof React }).React = React;
  (window as unknown as { ReactDOM: typeof ReactDOM }).ReactDOM = ReactDOM;
  (window as unknown as { global: typeof window }).global = window;
}

// Export to prevent tree-shaking
export { React, ReactDOM };